import { Component, OnInit } from '@angular/core';
import {ShoppingCartService} from '../../../../services/shopping-cart.service';
import {SwishPaymentService} from '../../../../services/swish-payment.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-swish-payment',
  templateUrl: './swish-payment.component.html',
  styleUrls: ['./swish-payment.component.css']
})
export class SwishPaymentComponent implements OnInit {
  payerSwishNumber: String;
  constructor(
    private swishPaymentService: SwishPaymentService,
    public  shoppingCartService: ShoppingCartService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private cookieService: CookieService) {}

  ngOnInit() {
  }
  pay() {
    this.spinner.show();
    this.swishPaymentService.sendSwishPaymentRequest(this.shoppingCartService.basket,
      this.payerSwishNumber).subscribe(
      (response) => {
        this.spinner.hide();
        // console.log(response);
        // console.log(response.statusText);
        // console.log(response.body);
        if (response.status === 200) {
          this.router.navigate(['/swish/confirmation'])
            .then(() => {
              this.cookieService.delete('basket');
              this.shoppingCartService.cleanUpShoppingCart();
            });
        }
      },
      (errorResponse: HttpErrorResponse) => {
        console.log('error: ', errorResponse);
        this.spinner.hide();
        if (errorResponse.status === 400) {
          // noinspection JSIgnoredPromiseFromCall
          this.router.navigate(['/swish/payment-fail'], {queryParams: {message: errorResponse.error.message}});
        } else {
          // noinspection JSIgnoredPromiseFromCall
          this.router.navigate(['/error']);
        }
      });
  }
}
